import React from "react";
import "./input.css";

/**
 * Textarea Component — standard multi-line text input.
 *
 * Uses the theme-level body text size so input text is uniform across the app.
 *
 * @param {Object} props
 * @param {string} props.className - Additional CSS classes (e.g. height/resize overrides)
 * @param {string} props.background - Field background ('default' = gray, 'white')
 * @param {boolean} props.error - Whether to show the validation error state
 * @param {Object} props.rest - Additional props passed to the native textarea
 */
const Textarea = React.forwardRef(({
    className = "",
    background = "default",
    error = false,
    ...rest
}, ref) => {
    const backgroundClass = background === "white" ? "ui-input--white" : "";
    const errorClass = error ? "ui-input--error" : "";

    return (
        <textarea
            ref={ref}
            className={`ui-input ${backgroundClass} ${errorClass} ${className}`.replace(/\s+/g, " ").trim()}
            {...rest}
        />
    );
});

Textarea.displayName = "Textarea";

export default Textarea;
